import { render, staticRenderFns } from "./AccordionRecipeSkeleton.vue?vue&type=template&id=5826afc8&scoped=true"
import script from "./AccordionRecipeSkeleton.vue?vue&type=script&lang=js"
export * from "./AccordionRecipeSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826afc8",
  null
  
)

export default component.exports